<section
    class="featured-notes-section">
    <div class="featured-notes-section__headline">
      <h2>Featured Notes</h2>
      <div
        *ngIf="showSearch"
        [ngClass]="{'show--bar': showSearchBarOnMobile}"
        class="search-bar">
        <search-content
          [props]="searchFormProps"
          [isPreviewMode]="true"
          [previewDefaultPhase]="'notd'"
          type="notes"></search-content>
      </div>
    </div>
    <div class="featured-notes-section__wrapper" *ngIf="(showPlaceholders && notes.length) || !showPlaceholders">
      <div 
        class="featured-notes-section__wrapper__note"
        *ngFor="let note of notes | slice:offset[0]:offset[1]; let i = index; let l = count">
        <img-lazy-loading
          class="note-img"
          *ngIf="note && note.thumbnails && note.thumbnailImage"
          [mainThumb]="note.thumbnailImage"
          [thumbs]="note.thumbnails"
          [url]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]"
          [title]="'Read more about ' + note.name"></img-lazy-loading>
        <div class="note-details">
          <a
            [routerLink]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]" title="Read about {{note.name}}"
            class="note-title">{{note.name}}</a>
          <p class="note-description">{{note.firstLeadWords}}</p>
          <div class="tags" *ngIf="note.price === 0">
            <!-- <span class="tag" *ngFor="let tag of note.tagLabels">{{tag}}</span> -->
            <span class="tag tag--free-note" *ngIf="note.price === 0">free note</span>
          </div>
          <div class="other-details" *ngIf="note.user">
            <a 
              class="by-user"
              [routerLink]="['/user', note.userId, 'profile']"
              *ngIf="note.userDisplayName">
              <img
                [alt]="note.user.displayName ? note.user.displayName : note.userDisplayName"
                class="avatar"
                *ngIf="note.user && note.user.profileImageUrl" [src]="note.user.profileImageUrl" />
                {{note.user.displayName ? note.user.displayName : note.userDisplayName}}
            </a>
            <span class="date">{{note.published || note.created | date: 'MMM dd, yyyy' }}</span>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showPlaceholders && !notes.length">
      <section class="featured-notes-section__wrapper">
        <section 
          class="featured-notes-section__wrapper__placeholder"
          *ngFor="let num of [].constructor(offset[1]); let i = index">
            <div class="featured-notes-section__wrapper__placeholder__image"></div>
            <div class="featured-notes-section__wrapper__placeholder__info"></div>
        </section>
      </section>
    </ng-container>
  </section>